export enum FormCreationType {
  DESTINATAIRE = 'Destinataire',
  LIVRAISON = 'Livraison',
  FOURNISSEUR = 'Fournisseur',
}
